export function clearTasks() {
    return {
        type: 'CLEAR_TASKS',
    }
}

export function clearTaskError() {
    return {
        type: 'CLEAR_TASK_ERRORS',
    }
}

export function closeGetTasksFetch() {
    return {
        type: 'API_GET_TASKS_CLOSE_FETCH',
    }
}

export function closeGetTaskFetch() {
    return {
        type: 'API_GET_TASK_CLOSE_FETCH',
    }
}

export function closePostTaskFetch() {
    return {
        type: 'API_POST_TASK_CLOSE_FETCH',
    }
}

export function closePutTaskFetch() {
    return {
        type: 'API_PUT_TASK_CLOSE_FETCH',
    }
}

export function closeDeleteTaskFetch() {
    return {
        type: 'API_DELETE_TASK_CLOSE_FETCH',
    }
}

export function getTasks(companyId) {
    return {
        type: 'API_GET_TASKS',
        payload: {
            request: {
                method: 'GET',
                url: `/companies/${companyId}/tasks`
            }
        }
    }
}

export function getTask(taskId) {
    return {
        type: 'API_GET_TASK',
        payload: {
            request: {
                method: 'GET',
                url: `/tasks/${taskId}`
            }
        }
    }
}

export function createTask(task, companyId) {
    return {
        type: 'API_CREATE_TASK',
        payload: {
            request: {
                method: 'POST',
                url: `/companies/${companyId}/tasks`,
                data: {
                    ...task,
                    company_id: companyId
                },
            }
        }
    }
}

export function updateTask(task) {
    return {
        type: 'API_UPDATE_TASK',
        payload: {
            request: {
                method: 'PUT',
                url: `/tasks/${task.id}`,
                data: task,
            }
        }
    }
}

export function deleteTask(task) {
    return {
        type: 'API_DELETE_TASK',
        payload: {
            request: {
                method: 'DELETE',
                url: `/tasks/${task.id}`,
            }
        }
    }
}

export function setEditTask(task) {
    return {
        type: 'SET_EDIT_TASK',
        payload: {
            task: task
        },
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/tasks.js